import { Avatar, Descriptions, Tag } from 'antd';
import { LockOutlined, LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Card, Button } from '../../components/ui';
import { getInitials } from '../../lib/initials';

export default function ProfilePage() {
	const navigate = useNavigate();
	const { user, logout, isLoggingOut } = useAuth();

	if (!user) return null;

	const initials = getInitials(user.name, user.email[0]?.toUpperCase() ?? 'U');

	return (
		<div className="max-w-2xl mx-auto">
			{/* Profile header */}
			<Card>
				<div className="flex items-center gap-5 mb-6">
					<Avatar size={72} src={user.avatar} className="bg-indigo-500 text-2xl flex-shrink-0">
						{initials}
					</Avatar>
					<div className="min-w-0">
						<h2 className="text-xl font-semibold text-gray-900 truncate">
							{user.name || user.username || user.email}
						</h2>
						<p className="text-sm text-gray-500 truncate">{user.email}</p>
						{user.roles && user.roles.length > 0 && (
							<div className="mt-2 flex flex-wrap gap-1">
								{user.roles.map((role) => (
									<Tag key={role} color="blue">{role}</Tag>
								))}
							</div>
						)}
						{!user.roles?.length && user.role && (
							<div className="mt-2">
								<Tag color="blue">{user.role}</Tag>
							</div>
						)}
					</div>
				</div>

				<Descriptions
					column={{ xs: 1, sm: 2 }}
					size="small"
					labelStyle={{ fontWeight: 500, color: '#6b7280' }}
				>
					{user.username && (
						<Descriptions.Item label="Username">{user.username}</Descriptions.Item>
					)}
					<Descriptions.Item label="Email">{user.email}</Descriptions.Item>
					{user.entityType && (
						<Descriptions.Item label="Entity type">{user.entityType}</Descriptions.Item>
					)}
					{user.tenantCode && (
						<Descriptions.Item label="Tenant">{user.tenantCode}</Descriptions.Item>
					)}
				</Descriptions>
			</Card>

			{/* Actions */}
			<Card className="mt-4">
				<h3 className="text-base font-semibold text-gray-900 mb-4">Account</h3>
				<div className="flex flex-col gap-3 sm:flex-row">
					<Button
						variant="secondary"
						icon={<LockOutlined />}
						onClick={() => navigate('/change-password')}
					>
						Change Password
					</Button>
					<Button
						variant="secondary"
						icon={<LogoutOutlined />}
						loading={isLoggingOut}
						onClick={() => logout()}
						danger
					>
						Logout
					</Button>
				</div>
			</Card>
		</div>
	);
}
